module.exports = __webpack_public_path__ + "static/img/15210901971.efe50d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15210901971.png
// module id = j4CP
// module chunks = 0